<template>
  <div class="elite-tabs-wrapper-content">
    <div class="custom-header">
      <div class="row">
          <h3 class="col-8" style="margin-left: -16px;">
            {{ `${auction.name}` }}
          </h3>
          <div class="col-4 text-right">
            <base-button
                type="button"
              @click="extractDetails"
              class="elite-button add text-right"
            >
              <span class="btn-inner--icon">
                <i class="far fa-download"></i>
              </span>
              <span class="btn-inner--text">
                {{ $t("COMMON.EXPORT") }}
              </span>
            </base-button>
              <!--<base-button
                  @click="printAwardCertificates()"
                  type="button"
                  class="elite-button btn-success text-right"
                  v-if="property.is_sold && property.sold_amount"
              >
                <span class="btn-inner--icon mr-1">
                  <i class="fa fa-file"></i>
                </span>
                <span class="btn-inner--text">
                  {{ $t("PROPERTIES.PRINT_AWARD_CERTIFICATE") }}
                </span>
              </base-button>-->
            </div>
        </div>
    </div>
    <div class="row mb-5">
      <div class="col-12">
        <dl class="row">
          <dt class="col-sm-4">{{ $t("AUCTIONS.NAME") }}</dt>
          <dd class="col-sm-8">
            {{ auction.name }}
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("AUCTIONS.OBJECT_TYPE") }}</dt>
          <dd class="col-sm-8">
            <span>
              {{ $t(`AUCTIONS.OBJECT_TYPE_${auction.object_type}`) }}
            </span>
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("AUCTIONS.AUCTION_TYPE") }}</dt>
          <dd class="col-sm-8">
            <span>
              {{ $t(`AUCTIONS.AUCTION_TYPE_${auction.auction_type}`) }}
            </span>
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("AUCTIONS.ACTIVATED_TIMER") }}</dt>
          <dd class="col-sm-8">
            <span v-if="auction.activated_timer">
              {{ $t("COMMON.YES") }}
            </span>
            <span v-else>
              {{ $t("COMMON.NO") }}
            </span>
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("AUCTIONS.PRE_OPENING_AT") }}</dt>
          <dd class="col-sm-8">
            <span v-if="auction.pre_opening_at">
              {{ $formatDate(auction.pre_opening_at, "LLL") }}
            </span>
            <span v-else>-</span>
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">
            {{ $t("AUCTIONS.LISTINGS_REGISTRATIONS_OPEN_AT") }}
          </dt>
          <dd class="col-sm-8">
            <span v-if="auction.listings_registrations_open_at">
              {{ $formatDate(auction.listings_registrations_open_at, "LLL") }}
            </span>
            <span v-else>-</span>
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">
            {{ $t("AUCTIONS.LISTINGS_REGISTRATIONS_CLOSE_AT") }}
          </dt>
          <dd class="col-sm-8">
            <span v-if="auction.listings_registrations_close_at">
              {{ $formatDate(auction.listings_registrations_close_at, "LLL") }}
            </span>
            <span v-else>-</span>
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("COMMON.START_AT") }}</dt>
          <dd class="col-sm-8">
            <span>
              {{ $formatDate(auction.start_at, "dddd D MMMM YYYY HH:mm") }}
            </span>
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("COMMON.END_AT") }}</dt>
          <dd class="col-sm-8">
            <span>
              {{ $formatDate(auction.end_at, "dddd D MMMM YYYY HH:mm") }}
            </span>
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("AUCTIONS.EXTENSION_TIME") }}</dt>
          <dd class="col-sm-8">
            <span>
              {{ auction.extension_time }}
            </span>
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("AUCTIONS.DELAY") }}</dt>
          <dd class="col-sm-8">
            <span>
              {{ auction.delay }}
            </span>
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("AUCTIONS.DELAY_BETWEEN_PROPERTIES") }}</dt>
          <dd class="col-sm-8">
            <span>
              {{ auction.delay_between_properties }}
            </span>
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("AUCTIONS.AUTHORIZED_PAYMENTS") }}</dt>
          <dd class="col-sm-8">
            <span v-for="(item, key) in auction.authorized_payments" :key="key">
              {{ $t(`AUCTIONS.PAYMENT_SOURCE_${item}`) }}
              {{ auction.authorized_payments.length - 1 > key ? "," : " " }}
            </span>
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("AUCTIONS.STARTING_AMOUNT_AUTOMATIC") }}</dt>
          <dd class="col-sm-8">
            <span v-if="auction.is_starting_amount_automatic">
              {{ $t("COMMON.YES") }}
            </span>
            <span v-else>
              {{ $t("COMMON.NO") }}
            </span>
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("COMMON.ADDRESS") }}</dt>
          <dd class="col-sm-8">
            <div v-html="auction.address"></div>
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("COMMON.CITY") }}</dt>
          <dd class="col-sm-8">
            <div v-html="auction.city"></div>
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("COMMON.ZIPCODE") }}</dt>
          <dd class="col-sm-8">
            <div v-html="auction.zipcode"></div>
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("COMMON.STATE") }}</dt>
          <dd class="col-sm-8">
            <div v-html="auction.state"></div>
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("COMMON.COUNTRY") }}</dt>
          <dd class="col-sm-8">
            <div v-html="auction.country"></div>
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("COMMON.LONGITUDE") }}</dt>
          <dd class="col-sm-8">
            <div v-html="auction.long"></div>
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("COMMON.LATITUDE") }}</dt>
          <dd class="col-sm-8">
            <div v-html="auction.lat"></div>
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("COMMON.EXCERPT") }}</dt>
          <dd class="col-sm-8">
            <div v-html="auction.excerpt"></div>
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("COMMON.LOCATIONS") }}</dt>
          <dd class="col-sm-8">
            <locations :locations="auction.allowedLocations" />
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("COMMON.MANAGERS") }}</dt>
          <dd class="col-sm-8">
            <users :users="auction.managers" />
          </dd>
        </dl>

        <dl
          class="row"
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_ORGANIZATIONS)"
        >
          <dt class="col-sm-4">{{ $t("COMMON.ORGANIZATION") }}</dt>
          <dd class="col-sm-8">
            <organization :organization="auction.organization" />
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("COMMON.CREATED_AT") }}</dt>
          <dd class="col-sm-8">
            {{ $formatDate(auction.created_at) }}
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("COMMON.UPDATED_AT") }}</dt>
          <dd class="col-sm-8">
            {{ $formatDate(auction.updated_at) }}
          </dd>
        </dl>
        <dl class="row">
          <dt class="col-sm-4">{{ $t("COMMON.LATITUDE") }}</dt>
          <dd class="col-sm-8">
            <div v-html="auction.lat"></div>
          </dd>
        </dl>
        <dl class="row" v-if="auction.advance_payment">
          <dt class="col-sm-4">{{ $t("AUCTIONS.ADVANCE_PAYMENT") }}</dt>
          <dd class="col-sm-8">
            <span>{{ $t(`AUCTIONS.ADVANCE_PAYMENT_${auction.advance_payment}`) }}</span>
          </dd>
        </dl>
        <dl class="row" v-if="auction.place">
          <dt class="col-sm-4">{{ $t("AUCTIONS.PLACE") }}</dt>
          <dd class="col-sm-8">
            <span>{{ $t(`AUCTIONS.PLACE_${auction.place}`) }}</span>
          </dd>
        </dl>
        <dl class="row">
          <dt class="col-sm-4">{{ $t("AUCTIONS.DEPOSIT_REQUIRED_TO_BET_ONLINE") }}</dt>
          <dd class="col-sm-8">
            <span v-if="auction.deposit_required_to_bet_online">
              {{ $t("COMMON.YES") }}
            </span>
            <span v-else>
              {{ $t("COMMON.NO") }}
            </span>
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
import { TAX_TYPE_AMOUNT, TAX_TYPE_PERCENTAGE } from "@/constants/taxes";
import Users from "@/components/Users.vue";

export default {
  name: "auction-view-global",

  props: ["auction"],

  components: {
    Users,
  },

  data() {
    return { TAX_TYPE_PERCENTAGE, TAX_TYPE_AMOUNT };
  },

  computed: {},

  created() {},

  methods: {
    auctionUpdated() {
      this.$emit("auctionUpdated", true);
    },
    extractDetails() {
      this.$emit("onExtractDetails", true);
    }
  },

  mounted() {},

  watch: {
    auction(auction) {},
  },
};
</script>
